/* Emițătorul de evenimente pentru blocurile de recomandări (PDP + coș).
 *
 * SURSA UNICĂ e acest fișier. Se copiază identic ca `assets/am-reco-tracking.js`
 * în tema DEV (theme-drafts/<dev>/assets/) și se include din `theme.liquid`.
 * Pe 12.09.2026 copia din temă a divergit tăcut de acest fișier; de aceea regula.
 *
 * NU e un Web Pixel: pixelul rulează într-un iframe fără acces la DOM și nu
 * poate publica evenimente. Ascultătorul e `ascultator-pixel.js` (vezi README).
 *
 * Publică DOUĂ evenimente prin `Shopify.analytics.publish`, prefixate cu
 * `audio_monkey:` ca să nu se ciocnească cu cele standard:
 *   reco_afisat — un grup de carduri VIZIBILE, cu aceeași ancoră, a stat în
 *                 viewport ≥ prag timp de ~1 s (standardul din
 *                 docs/recomandari-instrumentare-masurare.md §4)
 *   reco_click  — click pe LINKUL către produs al unui card
 * Adăugarea în coș NU se mai publică de aici (pe 12.09 producea două
 * `select_item` pentru un singur click și raporta „adăugat" înainte de răspunsul
 * AJAX). Emitem doar CONTEXTUL în sessionStorage; pixelul îl corelează cu
 * evenimentul standard `product_added_to_cart`, care vine doar la succes.
 *
 * Atribuirea VÂNZĂRILOR (docs/impact-interventii-spec.md §2.3) e al treilea rol, separat de
 * GA4: la click scrie `am_reco_atr_<produs>` (cât tab-ul), iar când RĂSPUNSUL unei adăugări
 * în coș (`POST …/cart/add[.js]`, prin `window.fetch` înfășurat) confirmă produsul, trimite un
 * `navigator.sendBeacon` la Worker cu codul coșului (fără secretul `key`). Doar răspunsul
 * confirmat raportează: o adăugare respinsă nu se numără, iar raportul nu așteaptă un timer.
 */
(function () {
  'use strict';

  var PREFIX_CONTEXT = 'am_reco_ctx_';
  var CHEIE_LEGACY = 'am_reco_context';
  var TTL_LINK = 30 * 60 * 1000;
  var TTL_DIRECT = 60 * 1000; // decizie de politică, nu latență măsurată
  var MAX_CONTEXTE = 100;

  /* Atribuirea VÂNZĂRILOR (docs/impact-interventii-spec.md §2.3, 25.09.2026). Context SEPARAT de
   * `am_reco_ctx_*`: acela expiră (30 min / 60 s) și e consumat de pixel la adăugare, pentru GA4.
   * Acesta ține cât tab-ul (sessionStorage) și nu îl atinge nimeni altcineva. La adăugarea în coș
   * a produsului, tema trimite Workerului codul coșului; comanda se leagă după el (nimic scris pe
   * comandă — decizia lui Tudor, 25.09). */
  var PREFIX_ATR = 'am_reco_atr_';
  var MAX_ATR = 100;
  var URL_RECO = 'https://audio-monkey-pm-ops.runtosip-dev.workers.dev/reco/adaugare';

  /* DOUĂ suprafețe, selectori DISJUNCȚI — măsurat pe DEV 12.09.2026 cu PDP +
   * sertarul coșului deschis simultan: 2 blocuri, 0 cu ambele clase. Structural:
   * blocul PDP pornește ca `#section-related` și primește `has-anchor` de la
   * `custom-async.js`; cel din coș e creat direct cu `cart-upsell`
   * (side-cart.liquid). */
  var SEL_COS = '.product-recommendations.cart-upsell';
  var SEL_PDP = '.product-recommendations.has-anchor';
  var SEL_BLOC = SEL_COS + ', ' + SEL_PDP;
  var SEL_CARD = 'li.product-card';
  /* DOAR linkul către produs. Cardul mai are un link către vendor
   * (`/collections/vendors?q=…`) și un buton de adăugare; niciunul nu e „click
   * pe recomandare". */
  var SEL_LINK = 'a[href*="pr_rec_pid"]';
  var SEL_ADAUGA = 'button[type="submit"], [name="add"], .btn-buy';

  var PRAG_DESKTOP = 0.5;   // standardul: ≥ 50 % vizibil
  var PRAG_MOBIL = 0.25;    // blocul are ~670 px; pe un ecran mic 50 % nu se atinge
  var DURATA_MS = 1000;     // menținut ~1 s

  function sursaBloc(bloc) {
    return bloc.classList.contains('cart-upsell') ? 'cos_complementare' : 'pdp';
  }

  /* Shopify pune în hreful cardului și `pr_rec_pid` (produsul recomandat) și
   * `pr_ref_pid` (ancora — produsul DE LA CARE a plecat recomandarea). Sunt
   * singura sursă din markup: cardurile de pe PDP n-au `data-product-id`. */
  function idDinHref(card, param) {
    var a = card.querySelector(SEL_LINK);
    if (!a) return null;
    var m = (a.getAttribute('href') || '').match(new RegExp('[?&]' + param + '=(\\d+)'));
    return m ? m[1] : null;
  }
  function idProdus(card) { return idDinHref(card, 'pr_rec_pid'); }

  /* Ancora per CARD, nu per bloc. În coș, blocul are `data-product-id="A,B"`
   * (câte un produs-sursă pentru fiecare linie din coș) și concatenează
   * recomandările tuturor — deci cardurile aceluiași bloc au ancore diferite.
   * Măsurat 12.09: card 0 → A, cardurile 1–2 → B. Fallback pe atributul
   * blocului DOAR când e un singur id (PDP); „A,B" nu e o ancoră. */
  function idAncora(card, bloc) {
    var a = idDinHref(card, 'pr_ref_pid');
    if (a) return a;
    var d = bloc && bloc.getAttribute('data-product-id');
    return (d && d.indexOf(',') === -1) ? d : null;
  }

  function publica(nume, date) {
    if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
      Shopify.analytics.publish('audio_monkey:' + nume, date);
    }
  }

  function contextValid(c, cheie, acum) {
    return c && /^\d+$/.test(c.produs) && cheie === PREFIX_CONTEXT + c.produs &&
      (c.sursa === 'pdp' || c.sursa === 'cos_complementare') && /^\d+$/.test(c.ancora) &&
      (c.tip === 'link' || c.tip === 'direct') &&
      typeof c.la === 'number' && isFinite(c.la) && c.la > 0 && c.la <= acum &&
      acum - c.la <= (c.tip === 'direct' ? TTL_DIRECT : TTL_LINK) &&
      typeof c.pozitie === 'number' && c.pozitie % 1 === 0 && c.pozitie >= 0 && c.pozitie <= 999;
  }

  // Sincron, doar namespace-ul propriu. Nu există read-modify-write comun
  // cu pixelul asincron. `limita` rezervă un loc înaintea unei chei noi.
  function curataContexte(limita) {
    sessionStorage.removeItem(CHEIE_LEGACY);
    var acum = Date.now(), valide = [];
    for (var i = sessionStorage.length - 1; i >= 0; i--) {
      var k = sessionStorage.key(i);
      if (!k || k.indexOf(PREFIX_CONTEXT) !== 0) continue;
      var c = null;
      try { c = JSON.parse(sessionStorage.getItem(k)); } catch (e) { /* invalid */ }
      if (!contextValid(c, k, acum)) sessionStorage.removeItem(k);
      else valide.push({ cheie: k, la: c.la });
    }
    valide.sort(function (a, b) { return a.la - b.la; });
    while (valide.length > limita) sessionStorage.removeItem(valide.shift().cheie);
    return valide;
  }

  function salveazaContext(date) {
    var cheie = PREFIX_CONTEXT + date.produs;
    try {
      var valide = curataContexte(MAX_CONTEXTE);
      if (!contextValid(date, cheie, Date.now())) return;
      if (sessionStorage.getItem(cheie) === null && valide.length >= MAX_CONTEXTE) {
        sessionStorage.removeItem(valide[0].cheie);
      }
      try { sessionStorage.setItem(cheie, JSON.stringify(date)); }
      catch (e) {
        if (e.name !== 'QuotaExceededError' && e.name !== 'NS_ERROR_DOM_QUOTA_REACHED') return;
        valide = curataContexte(MAX_CONTEXTE);
        if (valide.length) sessionStorage.removeItem(valide[0].cheie);
        // O singură reîncercare; spațiul e partajat, plafonul nu-l garantează.
        sessionStorage.setItem(cheie, JSON.stringify(date));
      }
    } catch (e) { /* storage indisponibil/plin: pierdem măsurarea, nu stricăm coșul */ }
  }

  function pozitieValida(p) {
    return typeof p === 'number' && p % 1 === 0 && p >= 0 && p <= 999;
  }

  // `pozitie: null` = cardul nu era afișabil la click (indexul -1); atribuirea rămâne valabilă.
  function atrValid(c, cheie) {
    return !!c && /^\d+$/.test(c.produs) && cheie === PREFIX_ATR + c.produs &&
      (c.sursa === 'pdp' || c.sursa === 'cos_complementare') && /^\d+$/.test(c.ancora) &&
      (c.pozitie === null || pozitieValida(c.pozitie)) &&
      typeof c.la === 'number' && isFinite(c.la) && c.la > 0;
  }

  // Doar prefixul propriu; cheile străine nu se ating. Suprascrierea aceleiași chei nu cere loc.
  function salveazaAtribuire(date) {
    var cheie = PREFIX_ATR + date.produs;
    var poz = pozitieValida(date.pozitie) ? date.pozitie : null;
    var rand = { sursa: date.sursa, produs: date.produs, ancora: date.ancora, pozitie: poz, la: Date.now() };
    try {
      if (!atrValid(rand, cheie)) return;
      var altele = [];
      for (var i = sessionStorage.length - 1; i >= 0; i--) {
        var k = sessionStorage.key(i);
        if (!k || k.indexOf(PREFIX_ATR) !== 0 || k === cheie) continue;
        var c = null;
        try { c = JSON.parse(sessionStorage.getItem(k)); } catch (e) { /* invalid */ }
        if (!atrValid(c, k)) sessionStorage.removeItem(k);
        else altele.push({ cheie: k, la: c.la });
      }
      altele.sort(function (a, b) { return a.la - b.la; });
      while (altele.length >= MAX_ATR) sessionStorage.removeItem(altele.shift().cheie);
      sessionStorage.setItem(cheie, JSON.stringify(rand));
    } catch (e) { /* storage indisponibil/plin: pierdem atribuirea, nu stricăm coșul */ }
  }

  function citesteAtribuire(produs) {
    try {
      var cheie = PREFIX_ATR + produs;
      var c = JSON.parse(sessionStorage.getItem(cheie));
      return atrValid(c, cheie) ? c : null;
    } catch (e) { return null; }
  }

  /* Codul coșului FĂRĂ secretul `key` (cu el, oricine ar putea modifica coșul). Cookie-ul
   * `cart` poate fi `<cod>` sau `<cod>?key=<secret>`, eventual URL-encoded. */
  function codCos() {
    var m = String(document.cookie || '').match(/(?:^|;\s*)cart=([^;]+)/);
    if (!m) return null;
    var v;
    try { v = decodeURIComponent(m[1]); } catch (e) { return null; }
    v = v.split('?')[0];
    return /^[A-Za-z0-9_-]{16,64}$/.test(v) ? v : null;
  }

  function piataCurenta() {
    var h = (typeof location !== 'undefined' && location && location.hostname) || '';
    return /\.bg$/.test(h) ? 'bg' : 'ro';
  }

  function trimiteAdaugarea(atr) {
    if (!permisAnalytics()) return;
    var cos = codCos();
    if (!cos || typeof navigator === 'undefined' || !navigator || !navigator.sendBeacon) return;
    try {
      navigator.sendBeacon(URL_RECO, JSON.stringify({
        cos: cos, produs: atr.produs, sursa: atr.sursa, ancora: atr.ancora, pozitie: atr.pozitie, piata: piataCurenta()
      }));
    } catch (e) { /* măsurarea se pierde, coșul nu */ }
  }

  /* ── Căutarea (docs/superpowers/plans/2026-09-29-cautare-venit-si-fara-rezultate.md) ─────────
   * A. Atribuirea vânzărilor din căutare: clic pe un rezultat din dropdown (`#livesearch`) sau de
   *    pe pagina `/search` (`.results > ul#collection`) scrie `am_cautare_atr_<produs>` — cheie
   *    SEPARATĂ de `am_reco_atr_`, ca un clic din căutare să nu suprascrie atribuirea unei
   *    recomandări. Adăugarea confirmată trimite beacon-ul cu `sursa` „cautare_*” și `termen`;
   *    Workerul îl scrie în `cautare_adaugari`.
   * B. Căutările fără rezultat: publică `audio_monkey:cautare_fara_rezultate` {termen, suprafata}
   *    O DATĂ per termen și pagină — în dropdown doar după ce mesajul „fără rezultate” a stat
   *    nemișcat ~1,5 s (nu la fiecare literă tastată). */
  var PREFIX_ATR_CAUTARE = 'am_cautare_atr_';
  var SEL_DROPDOWN_LINK = '#livesearch li[data-product-id] a';
  var SEL_PAGINA_LINK = '.results > ul#collection > li[data-product-id] a';
  var MAX_TERMEN = 60;
  var LINISTE_MS = 1500;

  function termenCautare(t) {
    if (typeof t !== 'string') return null;
    t = t.replace(/\s+/g, ' ').trim().slice(0, MAX_TERMEN).trim();
    return t.length >= 2 ? t : null;
  }

  function atrCautareValid(c, cheie) {
    return !!c && /^\d+$/.test(c.produs) && cheie === PREFIX_ATR_CAUTARE + c.produs &&
      (c.sursa === 'cautare_sugestii' || c.sursa === 'cautare_rezultate') &&
      (c.termen === null || (typeof c.termen === 'string' && c.termen.length <= MAX_TERMEN)) &&
      (c.pozitie === null || pozitieValida(c.pozitie)) &&
      typeof c.la === 'number' && isFinite(c.la) && c.la > 0;
  }

  function salveazaAtribuireCautare(date) {
    var cheie = PREFIX_ATR_CAUTARE + date.produs;
    var rand = { sursa: date.sursa, produs: date.produs, termen: termenCautare(date.termen),
      pozitie: pozitieValida(date.pozitie) ? date.pozitie : null, la: Date.now() };
    try {
      if (!atrCautareValid(rand, cheie)) return;
      var altele = [];
      for (var i = sessionStorage.length - 1; i >= 0; i--) {
        var k = sessionStorage.key(i);
        if (!k || k.indexOf(PREFIX_ATR_CAUTARE) !== 0 || k === cheie) continue;
        var c = null;
        try { c = JSON.parse(sessionStorage.getItem(k)); } catch (e) { /* invalid */ }
        if (!atrCautareValid(c, k)) sessionStorage.removeItem(k);
        else altele.push({ cheie: k, la: c.la });
      }
      altele.sort(function (a, b) { return a.la - b.la; });
      while (altele.length >= MAX_ATR) sessionStorage.removeItem(altele.shift().cheie);
      sessionStorage.setItem(cheie, JSON.stringify(rand));
    } catch (e) { /* storage indisponibil/plin: pierdem atribuirea, nu stricăm coșul */ }
  }

  function citesteAtribuireCautare(produs) {
    try {
      var cheie = PREFIX_ATR_CAUTARE + produs;
      var c = JSON.parse(sessionStorage.getItem(cheie));
      return atrCautareValid(c, cheie) ? c : null;
    } catch (e) { return null; }
  }

  /* Consimțământul (review Codex 29.09): atribuirea din căutare se scrie și se trimite DOAR cu
   * acord analitic CONFIRMAT. API-ul Shopify nu e încărcat implicit pe pagini (verificat pe live
   * 29.09: `Shopify.customerPrivacy` undefined), deci îl cerem la pornire; până se încarcă,
   * răspunsul e „nu” (fail-closed). La retragerea acordului ștergem atribuirile salvate. */
  function permisAnalytics() {
    try {
      var cp = window.Shopify && Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed() === true);
    } catch (e) { return false; }
  }

  /* Recomandările intră sub aceeași regulă din 29.09 (decizia lui Tudor): până atunci contextul și
   * atribuirea lor se scriau și beacon-ul pleca FĂRĂ verificarea acordului. La retragere se șterg
   * toate cele patru forme: atribuirea căutării, a recomandărilor, contextul GA4 și cheia veche. */
  function stergeAtribuirileFaraAcord() {
    try {
      sessionStorage.removeItem(CHEIE_LEGACY);
      for (var i = sessionStorage.length - 1; i >= 0; i--) {
        var k = sessionStorage.key(i);
        if (k && (k.indexOf(PREFIX_ATR_CAUTARE) === 0 || k.indexOf(PREFIX_ATR) === 0 ||
            k.indexOf(PREFIX_CONTEXT) === 0)) sessionStorage.removeItem(k);
      }
    } catch (e) { /* storage indisponibil */ }
  }

  var apiConsimtamantCerut = false;
  function cereApiConsimtamant() {
    try {
      if (apiConsimtamantCerut || (window.Shopify && Shopify.customerPrivacy)) return;
      if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
        apiConsimtamantCerut = true;
        Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (err) apiConsimtamantCerut = false; // se poate reîncerca la următorul prilej
        });
      }
    } catch (e) { apiConsimtamantCerut = false; }
  }

  /* Pe PDP și în coș nu există focus pe căutare care să reîncerce (review Codex 29.09): după `load`
   * reîncercăm la 2 s, de cel mult 8 ori, până apare `Shopify.customerPrivacy`. Până atunci rămâne
   * fail-closed: un clic înainte de încărcare nu se atribuie. */
  var incercariApi = 0;
  function reincearcaApiConsimtamant() {
    try {
      if (window.Shopify && Shopify.customerPrivacy) return;
      cereApiConsimtamant();
      if (++incercariApi < 8) setTimeout(reincearcaApiConsimtamant, 2000);
    } catch (e) { /* măsurarea se pierde, pagina nu */ }
  }

  function incarcaConsimtamantul() {
    // Ascultătorul de retragere se înregistrează ÎNTOTDEAUNA — și când API-ul e deja încărcat
    // (review Codex 29.09: un `return` timpuriu îl sărea).
    /* Verificat pe DEV 29.09: la pornirea emițătorului `Shopify.loadFeatures` poate să nu existe
     * încă, iar API-ul nu se mai încărca niciodată — atribuirea ar fi rămas oprită și CU acord.
     * Deci reîncercăm la `load` și la focusul barei de căutare (înainte de orice clic pe rezultat). */
    cereApiConsimtamant();
    try { window.addEventListener('load', reincearcaApiConsimtamant); } catch (e) { /* idem */ }
    try { document.addEventListener('focusin', function (ev) {
      if (ev.target && ev.target.id === 'search_main') cereApiConsimtamant();
    }); } catch (e) { /* idem */ }
    try {
      document.addEventListener('visitorConsentCollected', function () {
        if (!permisAnalytics()) stergeAtribuirileFaraAcord();
      });
    } catch (e) { /* idem */ }
  }

  function trimiteAdaugareaCautare(atr) {
    if (!permisAnalytics()) return;
    var cos = codCos();
    if (!cos || typeof navigator === 'undefined' || !navigator || !navigator.sendBeacon) return;
    try {
      navigator.sendBeacon(URL_RECO, JSON.stringify({
        cos: cos, produs: atr.produs, sursa: atr.sursa, termen: atr.termen, pozitie: atr.pozitie, piata: piataCurenta()
      }));
    } catch (e) { /* măsurarea se pierde, coșul nu */ }
  }

  /* Termenul dropdown-ului = interogarea care a DESENAT rezultatele, nu textul din bară la
   * momentul clicului (review Codex 29.09: clic pe rezultatele „kef” după ce s-a tastat „sony”
   * salva „sony”). `typesense-search.js` pune `data-am-q` pe `#livesearch` în `renderRows`, deci
   * aparține exact randării afișate. Fără atribut (temă veche) → null, nu o ghicire. */
  function termenDropdown() {
    var cont = document.getElementById('livesearch');
    return cont ? termenCautare(cont.getAttribute('data-am-q')) : null;
  }

  function termenPagina() {
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?search\/?$/i.test(location.pathname)) return null;
    try { return termenCautare(new URLSearchParams(location.search).get('q') || ''); } catch (e) { return null; }
  }

  function handleDin(href) {
    var m = String(href || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1].toLowerCase() : null;
  }

  /* Doar un link către PRODUSUL cardului (review Codex 29.09): cardul poate conține și WhatsApp
   * sau linkul altui produs (resigilat). Produsul cardului = handle-ul primului lui link /products/. */
  function linkulProdusului(a, li) {
    var h = handleDin(a.getAttribute('href'));
    var primul = li.querySelector('a[href*="/products/"]');
    return !!h && !!primul && handleDin(primul.getAttribute('href')) === h;
  }

  function pozitiaIn(li, selectorFrati) {
    var frati = li.parentNode ? li.parentNode.querySelectorAll(selectorFrati) : [];
    return Array.prototype.indexOf.call(frati, li);
  }

  document.addEventListener('click', function (ev) {
    if (!ev.target || !ev.target.closest) return;
    var a = ev.target.closest(SEL_DROPDOWN_LINK + ', ' + SEL_PAGINA_LINK);
    if (!a) return;
    var li = a.closest('li[data-product-id]');
    if (!li || !linkulProdusului(a, li) || !permisAnalytics()) return;
    var dinDropdown = !!a.closest('#livesearch');
    salveazaAtribuireCautare({
      sursa: dinDropdown ? 'cautare_sugestii' : 'cautare_rezultate',
      produs: li.getAttribute('data-product-id'),
      termen: dinDropdown ? termenDropdown() : termenPagina(),
      pozitie: pozitiaIn(li, ':scope > li[data-product-id]')
    });
  }, true);

  var faraRezultatePublicate = {};
  function publicaFaraRezultate(termen, suprafata) {
    if (!termen) return;
    var cheie = suprafata + '|' + termen.toLowerCase();
    if (faraRezultatePublicate[cheie]) return;
    faraRezultatePublicate[cheie] = true;
    publica('cautare_fara_rezultate', { termen: termen, suprafata: suprafata });
  }

  function urmaresteDropdown() {
    var cont = document.getElementById('livesearch');
    if (!cont || typeof MutationObserver === 'undefined') return;
    var timer = null;
    new MutationObserver(function () {
      if (timer) { clearTimeout(timer); timer = null; }
      if (!cont.querySelector('.ts-no-results-help') || cont.querySelector('li[data-product-id]')) return;
      // Interogarea care a produs mesajul (atributul randării), nu textul din bară: un răspuns
      // gol mai vechi raportează interogarea LUI, nu pe cea tastată între timp.
      var termen = termenDropdown();
      if (!termen) return;
      timer = setTimeout(function () {
        timer = null;
        if (cont.querySelector('.ts-no-results-help') && !cont.querySelector('li[data-product-id]') &&
            termenDropdown() === termen) publicaFaraRezultate(termen, 'dropdown');
      }, LINISTE_MS);
    }).observe(cont, { childList: true, subtree: true });
  }

  function verificaPaginaFaraRezultate() {
    var termen = termenPagina();
    if (!termen || !document.querySelector('.results')) return;
    if (document.querySelector('.results > ul#collection > li[data-product-id]')) return;
    publicaFaraRezultate(termen, 'pagina');
  }

  function pornesteCautarea() {
    incarcaConsimtamantul();
    try { urmaresteDropdown(); } catch (e) { /* măsurarea se pierde, pagina nu */ }
    try { verificaPaginaFaraRezultate(); } catch (e) { /* idem */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pornesteCautarea);
  else pornesteCautarea();

  try { curataContexte(MAX_CONTEXTE); } catch (e) { /* storage indisponibil */ }

  function carduriAfisabile(bloc) {
    return Array.prototype.filter.call(bloc.querySelectorAll(SEL_CARD), function (c) {
      return c.offsetParent !== null;
    });
  }
  function pozitieCard(card, bloc) { return carduriAfisabile(bloc).indexOf(card); }

  /* ── Impresia ──────────────────────────────────────────────────────────── */

  /* Grupează cardurile VIZIBILE ale unui bloc după ancoră. CSS-ul temei ascunde
   * cardurile de la al treilea încolo în coș (am-product-title.css, decizia
   * din 05.08) — 5 în DOM, 2 pe ecran; se raportează doar ce vede clientul. */
  function grupePerAncora(bloc) {
    var carduri = carduriAfisabile(bloc);
    var grupe = {}, pozitii = {}, ordine = [];
    for (var i = 0; i < carduri.length; i++) {
      var c = carduri[i];
      var p = idProdus(c), a = idAncora(c, bloc);
      if (!p || !a) continue;
      if (!grupe[a]) { grupe[a] = []; pozitii[a] = []; ordine.push(a); }
      grupe[a].push(p);
      pozitii[a].push(i);
    }
    return { grupe: grupe, pozitii: pozitii, ordine: ordine };
  }

  /* O impresie per (sursă, ancoră, set de produse) per încărcare de pagină.
   * Coșul se deschide/închide fără re-randare — fără gardă s-ar număra la
   * fiecare deschidere. Ancora e în amprentă fiindcă o re-randare pentru alt
   * produs-sursă cu același set de recomandări e o impresie NOUĂ. */
  var vazute = {};

  function raporteaza(bloc) {
    if (bloc.classList.contains('hidden')) return;   // tema încă adună răspunsurile AJAX
    var sursa = sursaBloc(bloc);
    var g = grupePerAncora(bloc);
    for (var i = 0; i < g.ordine.length; i++) {
      var ancora = g.ordine[i], ids = g.grupe[ancora];
      var amprenta = sursa + '|' + ancora + '|' + ids.join(',') + '|' + g.pozitii[ancora].join(',');
      if (vazute[amprenta]) continue;
      vazute[amprenta] = true;
      publica('reco_afisat', { sursa: sursa, ancora: ancora, produse: ids, pozitii: g.pozitii[ancora], numar_carduri: ids.length });
    }
  }

  function prag() { return window.innerWidth < 768 ? PRAG_MOBIL : PRAG_DESKTOP; }

  function programeaza(bloc) {
    if (bloc.__amRecoTimer) return;
    bloc.__amRecoTimer = setTimeout(function () {
      bloc.__amRecoTimer = null;
      if (bloc.__amRecoVizibil) raporteaza(bloc);
    }, DURATA_MS);
  }
  function anuleaza(bloc) {
    if (bloc.__amRecoTimer) { clearTimeout(bloc.__amRecoTimer); bloc.__amRecoTimer = null; }
  }

  var observator = null;
  function observatorVizibilitate() {
    if (observator || !('IntersectionObserver' in window)) return observator;
    observator = new IntersectionObserver(function (intrari) {
      for (var i = 0; i < intrari.length; i++) {
        var e = intrari[i], bloc = e.target;
        bloc.__amRecoVizibil = e.isIntersecting && e.intersectionRatio >= prag();
        if (bloc.__amRecoVizibil) programeaza(bloc); else anuleaza(bloc);
      }
    }, { threshold: [PRAG_MOBIL, PRAG_DESKTOP] });
    return observator;
  }

  function urmareste(bloc) {
    if (!bloc.__amRecoUrmarit) {
      bloc.__amRecoUrmarit = true;
      var o = observatorVizibilitate();
      if (o) o.observe(bloc);
      else { bloc.__amRecoVizibil = true; programeaza(bloc); } // fără IO: nu pierdem tot
    } else if (bloc.__amRecoVizibil) {
      /* Blocul e deja pe ecran și conținutul s-a schimbat (coșul s-a re-randat
       * pentru alt produs): IO nu mai declanșează, deci re-programăm noi. */
      anuleaza(bloc); programeaza(bloc);
    }
  }

  /* Blocurile se umplu ASINCRON (Section Rendering, câte un fetch per produs-sursă
   * și intent) — la DOMContentLoaded nu există. Urmărim mutațiile, cu o pauză
   * scurtă: tema mută multe clase, nu vrem un querySelectorAll la fiecare. */
  var pauza = null;
  function scaneaza() {
    clearTimeout(pauza);
    pauza = setTimeout(function () {
      var blocuri = document.querySelectorAll(SEL_BLOC);
      for (var i = 0; i < blocuri.length; i++) {
        if (blocuri[i].classList.contains('hidden')) continue;
        urmareste(blocuri[i]);
      }
    }, 150);
  }

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(scaneaza).observe(document.documentElement, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class']
    });
  }
  if (document.readyState !== 'loading') scaneaza();
  else document.addEventListener('DOMContentLoaded', scaneaza);

  /* ── Clickul ───────────────────────────────────────────────────────────── */

  /* Delegat pe document: cardurile se înlocuiesc la fiecare re-randare a
   * coșului, deci un listener pus direct pe ele ar muri tăcut. Capture, ca să
   * prindem clickul înainte ca navigarea să înceapă. */
  document.addEventListener('click', function (ev) {
    if (!ev.target || !ev.target.closest) return;
    var link = ev.target.closest(SEL_LINK);
    if (!link) return;
    var card = link.closest(SEL_CARD);
    var bloc = card && card.closest(SEL_BLOC);
    if (!bloc) return;
    var date = { sursa: sursaBloc(bloc), produs: idProdus(card), ancora: idAncora(card, bloc), pozitie: pozitieCard(card, bloc) };
    /* Contextul supraviețuiește navigării: dacă pe pagina produsului clientul
     * adaugă în coș, pixelul leagă adăugarea de recomandare și de ancoră. */
    if (permisAnalytics()) {
      salveazaContext({ sursa: date.sursa, produs: date.produs, ancora: date.ancora, pozitie: date.pozitie, tip: 'link', la: Date.now() });
      salveazaAtribuire(date);
    }
    publica('reco_click', date); // pixelul e deja filtrat de Shopify după acord
  }, true);

  /* Adăugarea din card (quick-buy în coș). Butonul NU e în interiorul linkului
   * (măsurat 12.09), deci cele două listenere nu se suprapun. Nu publicăm
   * nimic: doar contextul; confirmarea vine din `product_added_to_cart`. */
  document.addEventListener('click', function (ev) {
    if (!ev.target || !ev.target.closest) return;
    var buton = ev.target.closest(SEL_ADAUGA);
    if (!buton) return;
    var card = buton.closest(SEL_CARD);
    var bloc = card && card.closest(SEL_BLOC);
    if (!bloc) return;
    var date = { sursa: sursaBloc(bloc), produs: idProdus(card), ancora: idAncora(card, bloc), pozitie: pozitieCard(card, bloc) };
    if (!permisAnalytics()) return;
    salveazaContext({ sursa: date.sursa, produs: date.produs, ancora: date.ancora, pozitie: date.pozitie, tip: 'direct', la: Date.now() });
    salveazaAtribuire(date);
  }, true);

  /* ── Adăugarea în coș (atribuirea vânzărilor) ─────────────────────────────
   * Raportăm DOAR o adăugare CONFIRMATĂ de Shopify, imediat (final review 25.09, înlocuiește
   * ascultătorul `submit` + timerul de 1,5 s). Cel vechi raporta și adăugările RESPINSE (produs
   * deja în coș, cantitate peste stoc → apoi cumpărat oricum = vânzare atribuită fals) și pierdea
   * raportul când cookie-ul `cart` apărea după 1,5 s sau pagina pleca înainte.
   *
   * Toate căile temei trec prin `fetch` (custom-async.js: `mainProductAddToCart` trimite FormData
   * la `routes.cart_add_url`; bifele de upsell și tabelul trimit JSON la `/cart/add.js`), iar
   * răspunsul e o linie (`product_id`) sau `{items: [...]}`. Înfășurăm `window.fetch` O dată.
   * Wrapper-ul întoarce EXACT promisiunea originală; inspecția rulează pe o ramură separată,
   * în try/catch, cu `.then(…, function () {})` — nu poate respinge, întârzia sau schimba
   * cererea ori răspunsul temei. `r.clone()` lasă corpul necitit pentru temă. */
  function caleAdaugare(url) {
    var cale = String(url).replace(/^[a-z][a-z0-9+.-]*:\/\/[^\/]*/i, '').split(/[?#]/)[0];
    return /^(\/[a-z]{2}(-[a-z]{2,4})?)?\/cart\/add(\.js)?\/?$/i.test(cale);
  }

  function esteAdaugare(input, init) {
    var url = typeof input === 'string' ? input : (input && typeof input.url === 'string' ? input.url : null);
    if (!url || !caleAdaugare(url)) return false;
    var metoda = (init && init.method) || (input && typeof input === 'object' && input.method) || 'GET';
    return String(metoda).toUpperCase() === 'POST';
  }

  function produseRaspuns(json) {
    var linii = json && Array.isArray(json.items) ? json.items : [json];
    var vazut = {}, ids = [];
    for (var i = 0; i < linii.length; i++) {
      var id = linii[i] && linii[i].product_id;
      if (id === null || id === undefined) continue;
      id = String(id);
      if (!/^\d+$/.test(id) || vazut[id]) continue;
      vazut[id] = true;
      ids.push(id);
    }
    return ids;
  }

  function raporteazaRaspuns(r) {
    try {
      if (!r || !r.ok || typeof r.clone !== 'function') return;
      r.clone().json().then(function (json) {
        try {
          var ids = produseRaspuns(json);
          for (var i = 0; i < ids.length; i++) {
            var atr = citesteAtribuire(ids[i]);
            if (atr) trimiteAdaugarea(atr);
            // Căutarea are tabel propriu: aceeași adăugare se raportează și acolo, dacă există.
            var atrC = citesteAtribuireCautare(ids[i]);
            if (atrC) trimiteAdaugareaCautare(atrC);
          }
        } catch (e) { /* măsurarea se pierde, coșul nu */ }
      }, function () { /* JSON invalid: nimic */ });
    } catch (e) { /* corp consumat / clone indisponibil: nimic */ }
  }

  var fetchOriginal = window.fetch;
  if (typeof fetchOriginal === 'function' && !fetchOriginal.__amRecoAtr) {
    var fetchInfasurat = function (input, init) {
      var p = fetchOriginal.apply(this, arguments);
      try {
        if (esteAdaugare(input, init) && p && typeof p.then === 'function') {
          p.then(raporteazaRaspuns, function () { /* cererea temei a eșuat: nimic */ });
        }
      } catch (e) { /* inspecția nu are voie să strice cererea */ }
      return p;
    };
    fetchInfasurat.__amRecoAtr = true;
    window.fetch = fetchInfasurat;
  }
})();
